import Transactions from '../components/TransactionsSection/Transactions.component';
import { TransactionsProvider } from 'context/transactions/transactionsContext';

export const TransactionsPage = () => {
    return (
        <TransactionsProvider>
            <Transactions />
        </TransactionsProvider>
    );
};
